import { render, staticRenderFns } from "./PickinPage.vue?vue&type=template&id=44f9e557&scoped=true"
import script from "./PickinPage.vue?vue&type=script&lang=js"
export * from "./PickinPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f9e557",
  null
  
)

export default component.exports